
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import ColourSwatch from "@/vue/components/ColourSwatch.vue";
    import Colours from "@/utilities/Colours";

    @Component({ components: { ColourSwatch } })
    export default class ColourPicker extends Vue {

        // mounted(): void {
        // }

        @Prop({ required: true })
        value!: string;

        @Prop({ default: null })
        label?: string;

        @Prop({ default: () => [] })
        rules!: Array<(() => string | boolean) | ((v: any) => string | true)>

        onHexTextInput(value: string|null) {
            console.log("colour - onHexTextInput ", value);
            this.$emit("input", value);
        }

        get redDecimal(): string {
            return Colours.hexToRgb(this.value).r.toString();
        }
        set redDecimal(value: string) {
            const rgb = Colours.hexToRgb(this.value);
            //console.log(`Set red: r:${rgb.r} g:${rgb.g} b:${rgb.b} => ${+value}`);
            rgb.r = +value;
            //console.log(`... r:${rgb.r} g:${rgb.g} b:${rgb.b} toHex = ${Colours.rgbToHex(rgb)}`);
            this.$emit("input", Colours.rgbToHex(rgb));
        }

        get greenDecimal(): string {
            return Colours.hexToRgb(this.value).g.toString();
        }
        set greenDecimal(value: string) {
            const rgb = Colours.hexToRgb(this.value);
            rgb.g = +value;
            this.$emit("input", Colours.rgbToHex(rgb));
        }

        get blueDecimal(): string {
            return Colours.hexToRgb(this.value).b.toString();
        }
        set blueDecimal(value: string) {
            const rgb = Colours.hexToRgb(this.value);
            rgb.b = +value;
            this.$emit("input", Colours.rgbToHex(rgb));
        }
    }
